import React, { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { loadAnalytics } from "../../redux/actions";
import { analyticsSelector } from "../../redux/selectors";
import { Skeleton } from "@material-ui/lab";
import { DashboardSection } from "./DashboardSection";
import { HistoryContext } from "../../redux/historyContext";
import { useNavigate } from "../../hooks/useNavigate";
import { SecondaryAppBar } from "../common/SecondaryAppBar";
import { DashboardAppBar } from "./DashboardAppBar";
import { paramsToSearchString, searchStringToParams } from "../../utils/urlHelper";
import { useAuthorizationRoleOnly } from "../../hooks/useAuthorization";
import { CaseRoles } from "../../auth/CaseRoles";
import { Add, List } from "@material-ui/icons";
import { NewComplaintDialog } from "../dashboard/NewComplaintDialog";
const useStyles = makeStyles(theme => {
    return {
        root: {
            marginTop: 50,
        },
    };
});
export const AnalyticsDashboard = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const analyticsState = useSelector(analyticsSelector);
    const { data, loadingState } = analyticsState;
    const { location } = useContext(HistoryContext);
    const { search, pathname } = location;
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const navigate = useNavigate(location);
    const searchParams = useMemo(() => searchStringToParams(search), [search]);
    const navigateToNextQuery = (newParams) => {
        const nextQuery = paramsToSearchString(Object.assign(Object.assign({}, searchParams), newParams));
        navigate(`${pathname}${nextQuery}`);
    };
    useEffect(() => {
        dispatch(loadAnalytics(searchParams));
    }, [dispatch, searchParams]);
    const isAuthedForCreate = useAuthorizationRoleOnly(CaseRoles.admin, CaseRoles.helpdesk);
    const actions = [
        {
            title: "New Case",
            onClick: () => setIsDialogOpen(true),
            startIcon: React.createElement(Add, null),
            disabled: !isAuthedForCreate,
            "data-test": "new-case",
        },
        {
            title: "All cases",
            onClick: () => navigate("/complaints/list"),
            startIcon: React.createElement(List, null),
            disabled: false,
            "data-test": "cases-list",
        },
    ];
    const isLoaded = loadingState === "LOADED";
    if (isLoaded && (!data.sections || !data.sections.length)) {
        // if the dashboard fails to load any sections redirect to main list page
        navigate("/complaints");
    }
    return (React.createElement("div", { className: classes.root },
        React.createElement(SecondaryAppBar, { actions: actions },
            React.createElement(DashboardAppBar, { navigate: navigateToNextQuery, params: searchParams })),
        loadingState === "LOADED" ? (data.sections.map((section, index) => {
            return React.createElement(DashboardSection, { key: index, section: section });
        })) : (React.createElement(React.Fragment, null,
            React.createElement(Skeleton, { variant: "text", height: 60 }),
            React.createElement(Skeleton, { variant: "text", height: 60 }),
            React.createElement(Skeleton, { variant: "text", height: 60 }),
            React.createElement("br", null),
            React.createElement(Skeleton, { variant: "rect", height: 118 }))),
        isDialogOpen && (React.createElement(NewComplaintDialog, { isDialogOpen: isDialogOpen, onDialogClose: () => setIsDialogOpen(false) }))));
};
